<template>
  <div>
    <div v-if="!cards.length">
      <p class="lead">Add cards to this schedule and try again</p>
    </div>
    <div v-else>
      <p>Click on the reveal image to select or upload a custom image. All random images come from a vetted collection managed by Ambiki.</p>
      <div class="row">
        <div class="col text-center h3">Card</div>
        <div class="col text-center h3">Reveal Image</div>
      </div>
      <div v-for="(card, index) in cards" :key="`reveal_image_card_${card.card_id}`" class="row">
        <div class="col py-2 text-center" :class="{'border-bottom': index + 1 !== cards.length}"><b-img :src="card.image" height="100" rounded></b-img></div>
        <div class="col py-2 text-center" :class="{'border-bottom': index + 1!== cards.length}">
          <div v-if="revealImageForPosition(card)" class="d-flex flex-column align-items-center justify-content-center">
            <b-img :src="revealImageForPosition(card).image" height="100" rounded class="pointer" @click="handleSelectImage(card.position)"></b-img>
            <b-button variant="link" size="sm" @click="removeRevealImage(revealImageForPosition(card))"><b-icon icon="trash" /> Remove</b-button>
          </div>
          <div v-else
            class="bg-light mx-auto pointer rounded d-flex flex-column align-items-center justify-content-center"
            style="height: 100px; width: 250px"
            @click="handleSelectImage(card.position)">
            <b-icon icon="image" style="width: 50px; height: 50px" />
            <div>Random image</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['visualSchedule']),
    ...mapGetters(['revealImageForCardPosition']),

    cards() {
      return this.visualSchedule.visual_schedule_cards_attributes;
    },
  },

  methods: {
    ...mapMutations(['removeRevealImage']),

    handleSelectImage(position) {
      this.$emit('select-image', position);
    },

    revealImageForPosition(card) {
      return this.revealImageForCardPosition(card.position);
    },
  },
};
</script>
